import { Link } from "react-router-dom";
import { CreditCard, Crown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "");
const labels = { trial: "Free trial", trialing: "Free trial (card on file)", active: "Active", past_due: "Payment failed", canceled: "Ended", none: "No plan" };

export const SubscriptionSummary = () => {
  const { user } = useAuth();
  const b = user?.billing || {};
  if (b.is_admin) return <p className="text-sm flex items-center gap-2" data-testid="subscription-summary"><Crown className="h-4 w-4 text-amber-500" /> App owner — billing never applies to your account.</p>;
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3" data-testid="subscription-summary">
      <div className="text-sm">
        <div className="font-semibold" data-testid="subscription-status-label">{labels[b.status] || b.status}{b.plan ? ` · ${b.plan === "pro_yearly" ? "Yearly" : "Monthly"}` : ""}</div>
        <div className="text-muted-foreground text-xs mt-0.5">
          {(b.status === "trialing" || b.status === "trial") && `Trial ends ${fmt(b.trial_end)}`}
          {b.status === "active" && `${b.cancel_at_period_end ? "Ends" : "Renews"} ${fmt(b.current_period_end)}`}
          {b.comp_until && ` · Complimentary access until ${fmt(b.comp_until)}`}
        </div>
      </div>
      <Button asChild variant="outline" data-testid="subscription-manage-button"><Link to="/billing"><CreditCard className="h-4 w-4 mr-2" /> Manage plan</Link></Button>
    </div>
  );
};
